import React, { useState, useEffect, Fragment, useRef } from "react";
import "./loader.css";
import { IMG_LOGO_MINI } from "../../../constants/images";

let loaderCont = 0;
const LoaderComponent = (props) => (
  <div className={["bg-loader-transparent", props.noBackdrop ? "no-backdrop" : ""].join(" ")}>
    <div
      className={["loader-wrapper", props.loaderAbsolute ? "loader-wrapper-absolute" : ""].join(
        " "
      )}
    >
      <div className="loader d-flex align-items-center justify-content-center">
        <img src={IMG_LOGO_MINI} className="noselect" height="45" alt="" />
      </div>
      {/* <h1>Cargando datos...</h1> */}
      <div className="loader-section section-left"></div>
      <div className="loader-section section-right"></div>
    </div>
  </div>
);

const Loader = (props) => {
  const [show, setShow] = useState(false);
  const checkTimeout = useRef(null);
  useEffect(() => {
    if (loaderCont < 2) {
      setShow(true);
    } else {
      checkTimeout.current = setInterval(() => {
        if (loaderCont < 2) {
          loaderCont++;
          setShow(true);
          clearInterval(checkTimeout.current);
        }
      }, 100);
    }
    loaderCont++;

    return () => {
      clearInterval(checkTimeout.current);
      loaderCont--;
    };
  }, []);

  return <Fragment>{show && <LoaderComponent {...props} />}</Fragment>;
};

export default Loader;
